import HeadingLargeSummary from './HeadingLargeSummary';

export default HeadingLargeSummary;
